import styled from "@emotion/styled";

// Container for all radio items
export const StyleGroupRadioItems = styled.div`
  display: flex;
  /* flex-flow: row wrap; */
  row-gap: 20px;
  column-gap: 30px;
  align-items: center;
`;

// Each radio item wrapper
export const StyleGroupRadioItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

// Custom radio input
export const StyleRadio = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid ${(props: any) => props.theme.orange.orange500};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:checked {
    border-color: ${(props: any) => props.theme.orange.orange500};
    background-color: ${(props: any) => props.theme.colors.primary};

    &::after {
      content: "✔";
      color: white;
      font-size: 14px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &:focus {
    /* box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1); */
  }
`;

// Label for the radio button
export const StyleRadioLabel = styled.p`
  font-size: 14px;
  color: #000;
  margin: 0;
  cursor: pointer;
  user-select: none;
`;
